import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMemo } from 'react';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import { Text } from 'foundations-components/components/Text';
import { Box } from 'foundations-components/transitional/components/Box';
import { Flex } from 'foundations-components/components/Flex';
import { PrivateRadioOption } from './PrivateRadioOption';
import { PublicRadioOption } from './PublicRadioOption';
import { TeamRadioOption } from './TeamRadioOption';
import { getCheckedOptionFromView } from '../../getCheckedOptionFromView';
import { TASK_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { TaskViewSharingEditor } from '../TaskViewSharingEditor';
import { SharingUserDisplayPanel } from '../SharingUserDisplayPanel';
import { useAllTeams } from '../../useAllTeams';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ViewSharingEditor = ({
  originalView,
  viewUpdates,
  setViewUpdates,
  hasPublicPermission,
  hasTeamPermission,
  customSharedViewPermissionErrorMessage,
  showSharingPreview = false
}) => {
  const {
    data: allTeams
  } = useAllTeams();
  const checkedOption = getCheckedOptionFromView(viewUpdates);
  const currentTeam = useMemo(() => {
    if (!viewUpdates.teamId) {
      return undefined;
    }
    return allTeams.find(team => team.id === viewUpdates.teamId);
  }, [allTeams, viewUpdates.teamId]);
  if (originalView.objectTypeId === TASK_TYPE_ID) {
    return /*#__PURE__*/_jsx(TaskViewSharingEditor, {
      originalView: originalView,
      viewUpdates: viewUpdates,
      setViewUpdates: setViewUpdates
    });
  }
  if (!showSharingPreview) {
    return /*#__PURE__*/_jsx(FormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "viewsManagement.modals.manageSharing.label"
      }),
      children: /*#__PURE__*/_jsxs(ToggleGroup, {
        name: "view-sharing-options",
        display: "flex",
        flexDirection: "column",
        gap: "300",
        children: [/*#__PURE__*/_jsx(PrivateRadioOption, {
          viewUpdates: viewUpdates,
          setViewUpdates: setViewUpdates
        }), /*#__PURE__*/_jsx(TeamRadioOption, {
          originalView: originalView,
          viewUpdates: viewUpdates,
          setViewUpdates: setViewUpdates,
          hasSharedViewPermission: hasTeamPermission,
          customSharedViewPermissionErrorMessage: customSharedViewPermissionErrorMessage
        }), /*#__PURE__*/_jsx(PublicRadioOption, {
          viewUpdates: viewUpdates,
          setViewUpdates: setViewUpdates,
          hasSharedViewPermission: hasPublicPermission,
          customSharedViewPermissionErrorMessage: customSharedViewPermissionErrorMessage
        })]
      })
    });
  }
  return /*#__PURE__*/_jsxs(Flex, {
    minBlockSize: "300px",
    children: [/*#__PURE__*/_jsx(Box, {
      paddingBlockStart: "600",
      grow: 1,
      shrink: 1,
      basis: "0",
      children: /*#__PURE__*/_jsxs(ToggleGroup, {
        display: "flex",
        flexDirection: "column",
        gap: "300",
        name: "view-sharing-options",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h5",
          typography: "body-100",
          color: "text-core-default",
          marginBlockEnd: "200",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "viewsManagement.modals.manageSharing.sharingPanel.title"
          })
        }), /*#__PURE__*/_jsx(PrivateRadioOption, {
          viewUpdates: viewUpdates,
          setViewUpdates: setViewUpdates
        }), /*#__PURE__*/_jsx(TeamRadioOption, {
          originalView: originalView,
          viewUpdates: viewUpdates,
          setViewUpdates: setViewUpdates,
          hasSharedViewPermission: hasTeamPermission,
          customSharedViewPermissionErrorMessage: customSharedViewPermissionErrorMessage
        }), /*#__PURE__*/_jsx(PublicRadioOption, {
          viewUpdates: viewUpdates,
          setViewUpdates: setViewUpdates,
          hasSharedViewPermission: hasPublicPermission,
          customSharedViewPermissionErrorMessage: customSharedViewPermissionErrorMessage
        })]
      })
    }), /*#__PURE__*/_jsx(SharingUserDisplayPanel, {
      checkedOption: checkedOption,
      team: currentTeam ? {
        name: currentTeam.name,
        userIds: currentTeam.userIds
      } : undefined
    })]
  });
};